"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (props) {
    return _react2.default.createElement("path", { style: props.style, d: "m417.221 3.47c-56.509 0.0527-105.7 35.891-139.78 77.469-13.191 16.094-39.574 48.283-39.574 48.283-0.22075-6.9693-0.65655-14.571-2-19.363-13.99-49.92-67-86.04-118.69-82.8-38.484 2.4-79.87 19.95-101.08 53.2-23.894 37.46-10.563 85.62 7.609 123.02 34.091 70.179 96.408 119.46 142.6 180.72 28.401 37.662 37.761 84.718 52.678 128.44-0.82385 12.896 10.965 13.298 6.5 2.0703-1.5325-21.48 6.0708-42.802 12.807-63.047 15.416-46.332 44.051-87.495 81.812-118.5 53.661-44.058 121.05-69.379 168.51-121.26 36.683-40.108 57.984-103.94 27.879-152.12-22.572-36.125-63.911-56.144-99.268-56.111z", fill: "none", stroke: "#fff", strokeWidth: "10" });
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-parallax-3d/HeartIcon.js
// module id = 158
// module chunks = 0